import { axios } from '~/axios'

/**
 * Sends an email containing all usernames associated with the given email
 * address. The user is responsible for identifying which username is theirs.
 */
export async function sendUsernamesByEmail(email: string) {
  return await axios.post('/password/resetPasswordByEmail', null, {
    params: { email },
  })
}

/**
 * Updates the email of the currently authenticated user.
 */
export async function updateUserEmail(email: string) {
  return await axios.post<{
    data: { updateCurrentUserEmail: { successful: boolean } }
  }>('/graphql', {
    query:
      'mutation updateCurrentUserEmail($newEmail: String) { updateCurrentUserEmail(newEmail: $newEmail) { successful } }',
    variables: { newEmail: email },
  })
}
